import { Text } from '@prenuvo/shared-library';
import React from 'react';
import styled from 'styled-components';

export type MessageProps = {
  children: React.ReactNode;
};

// styles
// ----------------------------------------------------------------------

const CenterWrapper = styled.div`
  text-align: center;
  width: 100%;
  padding: 60px;
`;

// ----------------------------------------------------------------------

const Message = ({ children }: MessageProps) => {
  return (
    <CenterWrapper>
      <Text>{children}</Text>
    </CenterWrapper>
  );
};

export default Message;
